module.exports = __webpack_public_path__ + "static/media/eco-ecology-moon-svgrepo-com.dba6229c.svg";